import { faCheck, faQuestion, faXmark } from "@fortawesome/pro-regular-svg-icons";
import type { Badge } from "@comp-lib/components/StatusBadge.vue";

// Single source of truth for every Mobius subscription status badge, based on the subscription's is_active flag coming from the backend
export default function getSubscriptionStatusBadge(isActive: boolean | undefined): Badge {
  if (isActive === undefined) return { text: "Unknown", color: "gray", statusIcon: faQuestion };

  return isActive
    ? { text: "Active", color: "green", statusIcon: faCheck }
    : { text: "Inactive", color: "red", statusIcon: faXmark };
}
